export const generateLagLabel = (lagInSeconds: number): string => {
  const now = new Date();
  const lagDate = new Date(now.getTime() - lagInSeconds * 1000);

  const timeString = lagDate.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  let timeAgoText = "";

  if (lagInSeconds < 10) {
    timeAgoText = `just now`;
  } else if (lagInSeconds < 60) {
    timeAgoText = `few seconds ago`;
  } else if (lagInSeconds < 3600) {
    const minutes = Math.round(lagInSeconds / 60);
    timeAgoText = `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  } else if (lagInSeconds < 86400) {
    const hours = Math.round(lagInSeconds / 3600);
    timeAgoText = `${hours} hour${hours > 1 ? "s" : ""} ago`;
  } else {
    const days = Math.round(lagInSeconds / 86400);
    timeAgoText = `${days} day${days > 1 ? "s" : ""} ago`;
  }

  return `${timeString} (${timeAgoText})`;
};
